export const siteInfo = {
  name: 'kaiyuntiyu',
  fullName: 'kaiyuntiyu - 专业体育平台',
  slogan: '汇聚热爱，点燃激情',
  description: 'kaiyuntiyu是您值得信赖的专业体育平台，提供全面的体育资讯、赛事数据、直播服务与竞技娱乐体验。我们汇聚海量体育内容，满足每一位体育爱好者的需求。',
  domain: 'www.kaiyuntiyu.com',
  established: '2018',
  stats: {
    registeredUsers: '500万+',
    dailyActiveUsers: '80万+',
    articlesPublished: '10万+',
    categories: '5大分类',
    partners: '200+',
    coverage: '全球50+联赛',
  },
  milestones: [
    { year: '2018', title: '平台创立', description: 'kaiyuntiyu平台正式上线，以足球、篮球为核心业务起航' },
    { year: '2019', title: '品类扩展', description: '新增网球、电竞频道，平台日活突破50万' },
    { year: '2020', title: '直播上线', description: '推出体育直播服务，覆盖超过30个联赛的实时直播' },
    { year: '2021', title: '数据升级', description: '引入AI赛事数据分析系统，为球迷提供专业的比赛预测' },
    { year: '2022', title: '用户破500万', description: '注册用户突破500万，成为中国领先的体育资讯平台之一' },
    { year: '2023', title: '全球化布局', description: '拓展国际赛事版权，与多家海外体育媒体建立战略合作' },
    { year: '2024', title: '技术革新', description: '全面升级平台架构，推出个性化推荐与智能赛事提醒功能' },
  ],
  values: [
    { title: '专业权威', description: '汇聚行业资深体育编辑与数据分析师，确保每一条资讯的专业性与准确性', icon: 'ri-shield-check-line' },
    { title: '实时高效', description: '7x24小时不间断更新，第一时间传递赛场动态，让您永不错过精彩瞬间', icon: 'ri-flashlight-line' },
    { title: '海量全面', description: '覆盖全球50+顶级联赛，5大体育分类，满足各类体育爱好者的多样化需求', icon: 'ri-global-line' },
    { title: '用户至上', description: '以用户需求为核心，持续优化产品体验，打造最懂体育爱好者的服务平台', icon: 'ri-heart-line' },
  ],
  contact: {
    phone: '400-888-6666',
    email: 'contact@kaiyuntiyu.com',
    address: '中国北京市朝阳区体育中心大厦18层',
    wechat: 'kaiyuntiyu_official',
    weibo: '@kaiyuntiyu官方',
    workHours: '周一至周日 9:00 - 21:00',
  },
  faqs: [
    { question: 'kaiyuntiyu平台是否免费？', answer: '是的，kaiyuntiyu平台的基础资讯浏览、赛事数据查询等功能完全免费。部分高级数据分析和VIP直播服务需要订阅会员。' },
    { question: '如何在kaiyuntiyu注册账号？', answer: '点击页面右上角的"注册"按钮，输入手机号或邮箱，设置密码即可完成注册。整个过程只需1分钟。' },
    { question: 'kaiyuntiyu支持哪些赛事直播？', answer: 'kaiyuntiyu目前支持足球五大联赛、欧冠、NBA、CBA、四大满贯网球赛、英雄联盟全球总决赛等超过50个顶级赛事的直播服务。' },
    { question: '如何联系kaiyuntiyu客服？', answer: '您可以通过拨打客服热线400-888-6666、发送邮件至contact@kaiyuntiyu.com，或通过微信公众号"kaiyuntiyu_official"与我们取得联系。' },
    { question: 'kaiyuntiyu的资讯更新频率如何？', answer: 'kaiyuntiyu提供7x24小时不间断资讯更新服务，重大赛事期间更是实现分钟级实时战报推送，确保您第一时间获取最新动态。' },
    { question: 'kaiyuntiyu是否支持移动端访问？', answer: '当然！kaiyuntiyu全面支持移动端H5访问，同时也提供iOS和Android原生APP下载，让您随时随地畅享体育世界。' },
  ],
};